import axios from "axios";
import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../Loader";
const Addtestimonial = (props) => {
  const token = useSelector((state) => state.token);
  const [value, setValue] = useState(3);
  const [loader, setLoader] = useState(false);
  const {
    control,
    formState: { errors },
    register,
    watch,
    reset,
    handleSubmit
  } = useForm({
    defaultValues: {
      country: null,
      feedback: null,
      review: "3",
      userName: null,
      designation: null,
      image: null
    }
  });

  const addTestimonial = (data) => {
    setLoader(true);
    const Data = new FormData();
    Data.append("image", data.image[0]);
    Data.append("country", data.country);
    Data.append("feedback", data.feedback);
    Data.append("review", data.review);
    Data.append("userName", data.userName);
    Data.append("designation", data.designation);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/testimonial`,
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      },
      data: Data
    }).then(res => {
      setLoader(false);
      reset();
      toast(res.data.message, {
        theme: "light",
        position: "top-right",
        type: "success"
      });
      props.getData();
      props.onHide();
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme: "light",
          type: "error",
          position: "top-right"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to add testimonial", {
          theme: "light",
          type: "error",
          position: "top-right"
        })
      }
    });
  }

  const handleChange = (event) => {
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Form onSubmit={handleSubmit(addTestimonial)}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Add Testimonial
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="forCountry">
              <Form.Label>Country <span>*</span></Form.Label>
              <Form.Select
                className='form-control'
                aria-label="Default select example"
                {...register('country', {
                  required: { message: "Country is require", value: true }
                })}>
                <option value="United states of america">United states of america</option>
                <option value="Canada">Canada</option>
                <option value="Europe">Europe</option>
                <option value="China">China</option>
                <option value="Nigeria">Nigeria</option>
              </Form.Select>
              {errors.country ? <p className="errMsg">{errors.country.message}</p> : null}
            </Form.Group>
            <Form.Group className="mb-3" controlId="forFeedback">
              <Form.Label>Feedback <span>*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                {...register("feedback", {
                  required: { message: "Feedback is require", value: true },
                  minLength: { message: "Feedback is minimum 50 character is require", value: 50 }
                })} />
              {errors.feedback ? <p className="errMsg">{errors.feedback.message}</p> : null}
            </Form.Group>
            <Form.Group className="mb-3" controlId="forReview">
              <div className="d-flex align-items-center justify-content-between">
                <Form.Label>Review <span>*</span></Form.Label>
                <div className="bubble" style={{ left: `${(value - 1) * 25}%` }}>Star : {watch("review")}</div>
              </div>
              <Form.Range
                type="range"
                className="form-range"
                min="1"
                max="5"
                step="0.5"
                style={{ width: "100%" }}
                {...register("review", {
                  required: { message: "Review is require", value: true },
                  min: { value: 1, message: "Review is not valid" },
                  max: { value: 5, message: "Review is not valid" }
                })}
              />
              {errors.review ? <p className="errMsg">{errors.review.message}</p> : null}
            </Form.Group>
            <Form.Group className="mb-3" controlId="forName">
              <Form.Label>User Name <span>*</span></Form.Label>
              <Form.Control
                type="text"
                {...register('userName', {
                  required: { message: "User name is require", value: true }
                })} />
              {errors.userName ? <p className="errMsg">{errors.userName.message}</p> : null}
            </Form.Group>
            <Form.Group className="mb-3" controlId="forDesignation">
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                {...register("designation", {
                  required: { message: "Designation is require", value: true }
                })} />
              {errors.designation ? <p className="errMsg">{errors.designation.message}</p> : null}
            </Form.Group>
            <Form.Group className="mb-3" controlId="forUserImage">
              <Form.Label>User Image</Form.Label>
              <Form.Control
                type="file"
                {...register("image", {
                  required: { message: "User image is require", value: true },
                  validate: {
                    size: (file) => {
                      return file?.[0]?.size <= 2 * 1024 * 1024 || "File size exceeds 2MB"
                    },
                    type: (file) => {
                      return (
                        ["image/jpg", "image/jpeg", "image/png"].includes(file?.[0].type) || "Only support jpg and png");
                    }
                  }
                })} />
              {errors.image ? <p className="errMsg">{errors.image.message}</p> : null}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button className='button blue' type="submit" onClick={handleSubmit(addTestimonial)}>Add</Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loader show={loader} />
    </>
  )
}

export default Addtestimonial